import { render } from "./Bubble.vue?vue&type=template&id=916e328c&scoped=true"
import script from "./Bubble.vue?vue&type=script&lang=js"
export * from "./Bubble.vue?vue&type=script&lang=js"

import "./Bubble.vue?vue&type=style&index=0&id=916e328c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916e328c"]])

export default __exports__